import { useRouter } from 'next/router';
import LandingPageBanner from '@/components/LandingPageBanner/LandingPageBanner';
import { VideoLibrary } from './components/VideoLibrary';
import ImageGallery from './components/ImageGallery';
import PdfList from './components/PdfList';
import { Text } from '@mantine/core';
import FileList from './components/FilesList';
import PressKitCategories, { CategoryKey } from '../PressKit/data/categories';
import PressKitContents from './data/content';

export default function CategoryContentView() {
  const router = useRouter();

  const key = router.query.CategoryKey as CategoryKey;
  const category = PressKitCategories.find((category) => category.key === key);
  const contents = PressKitContents[key];

  const locale = router.locale || 'pt-BR';

  return (
    <>
      <div className="bg-['#1A1B1E'] m-auto">
        <LandingPageBanner
          isBlogDetail
          title={category?.title[locale] || 'Kit Imprensa'}
          banner={category?.image || '/assets/customize-your-plan-banner.png'}
        />
        <div className="max-w-[82.5rem] m-auto px-[20px] py-[60px]">
          {category?.description && (
            <Text fw="bold" size="xl" mb="xl">
              {category?.description[locale]}
            </Text>
          )}
          {category?.sectionText &&
            category.sectionText[locale]
              .split('\n')
              .map((text, index) => (
                <Text key={index} size="lg" mb="xl" dangerouslySetInnerHTML={{ __html: text }} />
              ))}
          {key === CategoryKey.MediaGallery && <ImageGallery contents={contents} ratio={16 / 9} />}
          {key === CategoryKey.VideoLibrary && <VideoLibrary contents={contents} />}
          {key === CategoryKey.PressReleases && <PdfList contents={contents} />}
          {key === CategoryKey.OurLogos && <FileList contents={contents} />}
          {key === CategoryKey.Team && <ImageGallery contents={contents} ratio={764 / 1081} />}
        </div>
      </div>
    </>
  );
}
